import { Col, Row, Popover, Button, message, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { useDispatch, useSelector } from 'react-redux';
import {
  breakName,
  convertDateToTimezone,
  convertTimeToTimezone,
  formatDateTo,
  getSubCategoryName,
} from '../../helpers/functions';
import QuotationModal from './modal/quatationModal';
import QuestionReplyModal from './modal/questionReplyModal';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactLinkify from 'react-linkify';
import { RequestRejectModal } from './modal/requestRejectModal';
import { nameRecommendationConstantForToolTip } from '../../helpers/constant';
import useResponsive from '../../hooks/useBreakpoint';
import { use } from 'react';

const ExpertRequestCard = props => {
  const breakpoint = useResponsive();
  const [open, setOpen] = useState(false);

  const [showPopover, setShowPopover] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState();
  const [loading, setLoading] = useState(false);

  const [quotationModal, setQuotationModal] = useState(false);
  const [showRequestRejectModal, setShowRequestRejectModal] = useState(false);
  const { acceptOrRejectExpertRequestStatus, isAcceptOrRejectExpertRequestLoading } = useSelector(
    state => state.requests,
  );
  const currentLocation = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const showQuotationModal = () => {
    setShowPopover(false);
    setQuotationModal(true);
  };

  const content = (
    <div className="status-popover-content-container">
      <div className="status-popover-inner-container">
        <div
          onClick={() => {
            dispatch({
              type: 'UPDATE_QUESTION_STATUS',
              formData: { question_id: props?.id, question_status_id: 10 },
            });
            if (props?.navigateBackOnCancel) {
              navigate('/dashboard/expert/request');
            }
          }}
          className="status-popover-cancel-button"
        >
          Cancel Request
        </div>
      </div>
    </div>
  );
  const getDynamicActionView = () => {
    if (
      props?.status?.question_status?.id === 13 ||
      (props?.status?.question_status?.id > 7 && props?.status?.question_status?.id < 10)
    ) {
      return (
        breakpoint && (
          <>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={11}
              xxl={11}
              // className="requests-history-accounting-col"
            >
              <div
                className={`${
                  breakpoint === 'xs' ||
                  breakpoint === 'sm' ||
                  breakpoint === 'md' ||
                  breakpoint === 'lg'
                    ? ' d-flex-a-c'
                    : 'f-flex-a-e'
                } expert-request-button-group`}
                style={{
                  flexDirection: breakpoint === 'xs' || breakpoint === 'sm' ? 'column' : '',
                  gap: '10px',
                }}
              >
                {location.pathname === `/dashboard/expert/request/active/${props?.id}` && (
                  <Button
                    style={{
                      minWidth: breakpoint === 'xs' || breakpoint === 'sm' ? '100%' : '160px',
                    }}
                    className="expert-request-button"
                    type="primary"
                    onClick={() => {
                      props?.setSelectedTab('messaging');
                    }}
                  >
                    Messaging
                  </Button>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',

                    width: breakpoint === 'xs' || breakpoint === 'sm' ? '100%' : '160px ',
                  }}
                >
                  <Button
                    style={{
                      minWidth:
                        (breakpoint === 'xs' || breakpoint === 'sm') &&
                        location.pathname === `/dashboard/expert/request/active/${props?.id}`
                          ? '90%'
                          : '100% ',
                    }}
                    className="expert-request-button"
                    danger
                    onClick={() => handleMarkAsComplete(props)}
                  >
                    Mark as completed
                  </Button>
                  {(breakpoint === 'xs' || breakpoint === 'sm') &&
                    location.pathname === `/dashboard/expert/request/active/${props?.id}` &&
                    popoverMenu()}
                </div>
                <Button
                  style={{
                    width: !(breakpoint === 'xs' || breakpoint === 'sm')
                      ? '160px !important'
                      : '100% ! important',
                  }}
                  className="expert-request-button"
                  type="primary"
                  disabled={
                    props?.status?.question_status?.name != 'Job started' &&
                    props?.status?.question_status?.name != 'Accepted' &&
                    props?.status?.question_status?.name != 'Quotation Rejected'
                  }
                  onClick={() => showQuotationModal(props)}
                >
                  Send a quotation
                </Button>

                {props.isClickable && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      minWidth: !(breakpoint === 'xs' || breakpoint === 'sm') ? '160px' : '100%',
                    }}
                  >
                    <Button
                      className="expert-request-button"
                      style={{
                        width: !(breakpoint === 'xs' || breakpoint === 'sm') ? '100%' : '90%',
                      }}
                      onClick={props.onClick}
                    >
                      View Details
                    </Button>
                    {(breakpoint === 'xs' || breakpoint === 'sm') && popoverMenu()}
                  </div>
                )}
                {!(breakpoint === 'xs' || breakpoint === 'sm') && popoverMenu()}
              </div>
            </Col>
          </>
        )
      );
    } else if ([4, 5, 13].includes(props?.status?.question_status?.id)) {
      return (
        breakpoint && (
          <>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={11}
              xxl={11}
              className="requests-history-accounting-col"
            >
              <div
                className={`
              ${
                breakpoint === 'xs' ||
                breakpoint === 'sm' ||
                breakpoint === 'md' ||
                breakpoint === 'lg'
                  ? ' d-flex-a-c'
                  : 'f-flex-a-e'
              } expert-request-button-group`}
                style={{
                  flexDirection: breakpoint === 'xs' || breakpoint === 'sm' ? 'column' : 'row',
                  gap: '10px',
                }}
              >
                {location.pathname === `/dashboard/expert/request/active/${props?.id}` && (
                  <Button
                    style={{
                      minWidth: breakpoint === 'xs' || breakpoint === 'sm' ? '100%' : '160px',
                    }}
                    className="expert-request-button"
                    type="primary"
                    onClick={() => {
                      props?.setSelectedTab('messaging');
                    }}
                  >
                    Messaging
                  </Button>
                )}

                <Button
                  style={{
                    width:
                      breakpoint &&
                      (breakpoint === 'xxl' ||
                      breakpoint === 'xl' ||
                      breakpoint === 'lg' ||
                      breakpoint === 'md'
                        ? '10rem !important'
                        : '100% !important'),
                  }}
                  className="expert-request-button"
                  type="primary"
                  disabled={
                    props?.status?.question_status?.name != 'Job started' &&
                    props?.status?.question_status?.name != 'Accepted' &&
                    props?.status?.question_status?.name != 'Quotation Rejected'
                  }
                  onClick={() => showQuotationModal()}
                >
                  Send a quotation
                </Button>
                {props.isClickable && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      minWidth: !(breakpoint === 'xs' || breakpoint === 'sm') ? '160px' : '100%',
                    }}
                  >
                    <Button
                      className="expert-request-button"
                      style={{
                        width: !(breakpoint === 'xs' || breakpoint === 'sm') ? '100%' : '90%',
                      }}
                      onClick={props.onClick}
                    >
                      View Details
                    </Button>
                    {(breakpoint === 'xs' || breakpoint === 'sm') && popoverMenu()}
                  </div>
                )}
                {!(breakpoint === 'xs' || breakpoint === 'sm') && popoverMenu()}
              </div>
            </Col>
          </>
        )
      );
    } else {
      return (
        breakpoint && (
          <>
            <Col span={6} className="requests-history-accounting-col">
              <div className="status f-flex-a-s-j-e">
                <div className="date">
                  <div className="p-title">Started on</div>
                  <h3 className="title-date title">
                    {props?.status?.created_at ? (
                      <>
                        {convertDateToTimezone(props?.status?.created_at)} <br />{' '}
                        {convertTimeToTimezone(props?.status?.created_at)}
                      </>
                    ) : (
                      '-'
                    )}
                  </h3>
                </div>
              </div>
            </Col>
            <Col>{popoverMenu()}</Col>
          </>
        )
      );
    }
  };
  const handleMarkAsComplete = data => {
    dispatch({
      type: 'UPDATE_QUESTION_STATUS',
      formData: { question_id: data?.id, question_status_id: 11 },
    });
    if (props?.navigateBackOnCancel) {
      navigate('/dashboard/expert/request');
    }
  };

  const onAcceptNewRequest = id => {
    setLoading(true);
    dispatch({
      type: 'POST_ACCEPT_OR_REJECT_EXPERT_REQUEST',
      formData: { question_id: id, accepted: 1 },
    });
    if (props?.navigateBackOnCancel) {
      navigate('/dashboard/expert/request');
    }
  };

  const getDynamicView = type => {
    switch (type) {
      case 'NewRequest':
        return (
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={9}
            xxl={9}
            className="requests-history-accounting-col"
          >
            {props?.status?.question_status?.id === 3 ? (
              <div className="f-flex-a-e expert-request-button-group">
                {/* Hide messaging button when not in details view */}
                {!props.isClickable && (
                  <Button
                    className="expert-request-button"
                    type="primary"
                    onClick={() => props?.setSelectedTab('messaging')}
                  >
                    Messaging
                  </Button>
                )}
                <Tooltip
                  title={
                    props?.assign_by_admin === 1 &&
                    props?.expert_approved === 0 &&
                    'Waiting on client approval'
                  }
                >
                  <Button
                    className="expert-request-button"
                    type={
                      props?.assign_by_admin === 1 && props?.expert_approved === 0
                        ? 'default'
                        : 'primary'
                    }
                    loading={loading}
                    disabled={props?.assign_by_admin === 1 && props?.expert_approved === 0}
                    onClick={() => {
                      if (props?.expert_approved === 1) {
                        onAcceptNewRequest(props.id);
                        props?.setTabNameAndKey(1);
                      } else {
                        message.error('Waiting for client approval.');
                      }
                    }}
                  >
                    Accept
                  </Button>
                </Tooltip>
                {/* <Button onClick={()=>{props?.setTabNameAndKey(1)}}>accept</Button> */}
                <Tooltip
                  title={
                    props?.assign_by_admin === 1 &&
                    props?.expert_approved === 0 &&
                    'Waiting on client approval'
                  }
                >
                  <Button
                    className="expert-request-button"
                    type="default"
                    loading={loading}
                    disabled={props?.assign_by_admin === 1 && props?.expert_approved === 0}
                    onClick={() => {
                      if (props?.expert_approved === 1) {
                        setShowRequestRejectModal(true);
                      } else {
                        message.error('Waiting for client approval.');
                      }
                    }}
                  >
                    Reject
                  </Button>
                </Tooltip>
                {props.isClickable && (
                  <Button className="expert-request-button" onClick={props.onClick}>
                    View Details
                  </Button>
                )}
              </div>
            ) : null}
          </Col>
        );
      case 'ActiveRequest':
        return (
          <>
        
            {props?.status?.question_status?.id === 13 ||
            (props?.status?.question_status?.id > 7 && props?.status?.question_status?.id < 10)
              ?  (
                  <Col xs={24} sm={24} md={24} lg={24} xl={11} xxl={11}>
                    <div
                      className={`${
                        ['xs', 'sm', 'md', 'lg'].includes(breakpoint) ? ' d-flex-a-c' : 'f-flex-a-e'
                      } expert-request-button-group`}
                      style={{
                        flexDirection: ['xs', 'sm'].includes(breakpoint) ? 'column' : '',
                        gap: '10px',
                      }}
                    >
                      {location.pathname === `/dashboard/expert/request/active/${props?.id}` && (
                        <Button
                          style={{
                            minWidth: ['xs', 'sm'].includes(breakpoint) ? '100%' : '160px',
                          }}
                          className="expert-request-button"
                          type="primary"
                          onClick={() => props?.setSelectedTab('messaging')}
                        >
                          Messaging
                        </Button>
                      )}

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: ['xs', 'sm'].includes(breakpoint) ? '100%' : '160px',
                        }}
                      >
                        <Button
                          style={{
                            minWidth:
                              ['xs', 'sm'].includes(breakpoint) &&
                              location.pathname === `/dashboard/expert/request/active/${props?.id}`
                                ? '90%'
                                : '100%',
                          }}
                          className="expert-request-button"
                          danger
                          onClick={() => handleMarkAsComplete(props)}
                        >
                          Mark as completed
                        </Button>
                        {['xs', 'sm'].includes(breakpoint) &&
                          location.pathname === `/dashboard/expert/request/active/${props?.id}` &&
                          popoverMenu()}
                      </div>

                      <Button
                        style={{
                          width: !['xs', 'sm'].includes(breakpoint)
                            ? '160px !important'
                            : '100% !important',
                        }}
                        className="expert-request-button"
                        type="primary"
                        disabled={
                          !['Job started', 'Accepted', 'Quotation Rejected'].includes(
                            props?.status?.question_status?.name,
                          )
                        }
                        onClick={() => showQuotationModal(props)}
                      >
                        Send a quotation
                      </Button>

                      {props.isClickable && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            minWidth: !['xs', 'sm'].includes(breakpoint) ? '160px' : '100%',
                          }}
                        >
                          <Button
                            className="expert-request-button"
                            style={{
                              width: !['xs', 'sm'].includes(breakpoint) ? '100%' : '90%',
                            }}
                            onClick={props.onClick}
                          >
                            View Details
                          </Button>
                          {['xs', 'sm'].includes(breakpoint) && popoverMenu()}
                        </div>
                      )}

                      {!['xs', 'sm'].includes(breakpoint) && popoverMenu()}
                    </div>
                  </Col>
                )
              : [4, 5, 13].includes(props?.status?.question_status?.id)
                ?   (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={11}
                      xxl={11}
                      className="requests-history-accounting-col"
                    >
                      <div
                        className={`${
                          ['xs', 'sm', 'md', 'lg'].includes(breakpoint)
                            ? ' d-flex-a-c'
                            : 'f-flex-a-e'
                        } expert-request-button-group`}
                        style={{
                          flexDirection: ['xs', 'sm'].includes(breakpoint) ? 'column' : 'row',
                          gap: '10px',
                        }}
                      >
                        {location.pathname === `/dashboard/expert/request/active/${props?.id}` && (
                          <Button
                            style={{
                              minWidth: ['xs', 'sm'].includes(breakpoint) ? '100%' : '160px',
                            }}
                            className="expert-request-button"
                            type="primary"
                            onClick={() => props?.setSelectedTab('messaging')}
                          >
                            Messaging
                          </Button>
                        )}

                        <Button
                          style={{
                            width: ['xxl', 'xl', 'lg', 'md'].includes(breakpoint)
                              ? '10rem !important'
                              : '100% !important',
                          }}
                          className="expert-request-button"
                          type="primary"
                          disabled={
                            !['Job started', 'Accepted', 'Quotation Rejected'].includes(
                              props?.status?.question_status?.name,
                            )
                          }
                          onClick={() => showQuotationModal()}
                        >
                          Send a quotation
                        </Button>

                        {props.isClickable && (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              minWidth: !['xs', 'sm'].includes(breakpoint) ? '160px' : '100%',
                            }}
                          >
                            <Button
                              className="expert-request-button"
                              style={{
                                width: !['xs', 'sm'].includes(breakpoint) ? '100%' : '90%',
                              }}
                              onClick={props.onClick}
                            >
                              View Details
                            </Button>
                            {['xs', 'sm'].includes(breakpoint) && popoverMenu()}
                          </div>
                        )}
                        {!['xs', 'sm'].includes(breakpoint) && popoverMenu()}
                      </div>
                    </Col>
                  )
                :   (
                    <>
                      <Col span={6} className="requests-history-accounting-col">
                        <div className="status f-flex-a-s-j-e">
                          <div className="date">
                            <div className="p-title">Started on</div>
                            <h3 className="title-date title">
                              {props?.status?.created_at ? (
                                <>
                                  {convertDateToTimezone(props?.status?.created_at)} <br />
                                  {convertTimeToTimezone(props?.status?.created_at)}
                                </>
                              ) : (
                                '-'
                              )}
                            </h3>
                          </div>
                        </div>
                      </Col>
                      <Col>{popoverMenu()}</Col>
                    </>
                  )}
          </>
        );

      case 'RequestHistory':
        return (
          <>
            <Col span={4} className="requests-history-accounting-col">
              <div className="status">
                <div className="date">
                  <div className="p-title">Completed on </div>
                  <h3 className="title-date title">
                    {props?.status?.updated_at
                      ? convertDateToTimezone(props?.status?.updated_at, 'MMM DD, YYYY')
                      : '-'}
                    <br />
                    {props?.status?.updated_at
                      ? convertTimeToTimezone(props?.status?.updated_at, 'MMM DD, YYYY')
                      : '-'}
                  </h3>
                </div>
              </div>
            </Col>

            {props.isClickable && (
              <Col span={4}>
                <div className="f-flex-a-e expert-request-button-group">
                  <Button className="expert-request-button" onClick={props.onClick}>
                    View Details
                  </Button>
                </div>
              </Col>
            )}
          </>
        );
      case 'MarkAsComplete':
        return (
          <>
            {props?.status?.question_status?.id > 7 && props?.status?.question_status?.id < 10 && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={9}
                xxl={9}
                className="requests-history-accounting-col"
              >
                <div
                  className={`${breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md' || breakpoint === 'lg' ? ' d-flex-a-c' : 'f-flex-a-e'} expert-request-button-group`}
                >
                  <Button
                    style={{
                      width: !(breakpoint === 'xs' || breakpoint === 'sm')
                        ? '160px ! important'
                        : '100% ! important',
                    }}
                    className="assigned-to-profile-button"
                    onClick={() => handleMarkAsComplete(props)}
                    danger
                  >
                    Mark as completed
                  </Button>
                  {props.isClickable && (
                    <Button className="expert-request-button" onClick={props.onClick}>
                      View Details
                    </Button>
                  )}
                  {popoverMenu()}
                </div>
              </Col>
            )}
          </>
        );
      case 'QuestionCard':
        return (
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={5}
            xxl={5}
            className="requests-history-accounting-col"
          >
            <div className="f-flex-a-e expert-request-button-group">
              {/* <Button className="expert-request-button" type="default" onClick={props?.onRejectRequestClick ? props?.onRejectRequestClick : null}>Reject</Button> */}
              <Button
                className="expert-request-button"
                onClick={() => {
                  setSelectedRowData(props);
                  setOpen(true);
                }}
              >
                View Question
              </Button>
            </div>
          </Col>
        );
      default:
        return;
    }
  };

  const popoverMenu = () => (
    <Popover
      placement="bottomLeft"
      content={content}
      trigger="click"
      open={showPopover}
      showArrow={false}
      onOpenChange={visible => setShowPopover(visible)}
    >
      <div className="status-popover-option-icon">
        <HiOutlineDotsVertical size={32} />
      </div>
    </Popover>
  );

  return (
    <div className="requests-history-accounting">
      <Row className="requests-history-accounting-row">
        <Col
          onClick={props.isClickable ? props.onClick : undefined}
          className="requests-history-accounting-col"
          style={{ cursor: props.isClickable ? 'pointer' : 'default' }}
          xs={8}
          sm={8}
          md={8}
          lg={8}
          xl={3}
          xxl={5}
        >
          {props.type === 'QuestionCard' ? (
            <div className="question-card-description pr-4">
              <ReactLinkify>
                {props?.question_disc?.length >= 140
                  ? props?.question_disc?.substring(0, 140) + '...'
                  : props?.question_disc}
              </ReactLinkify>
            </div>
          ) : (
            <div className="id pr-4">
              <div className="p-title">ID #{props.id}</div>
              <h3 className="title">{props?.category?.name ? props?.category?.name : '-'}</h3>
              <p
                style={{
                  fontSize:
                    getSubCategoryName(props)?.length < 50
                      ? 'clamp(14px, 2.5vw, 16px)'
                      : 'clamp(12px, 2.5vw, 14px)',
                  lineHeight:
                    getSubCategoryName(props)?.length < 45
                      ? 'clamp(20px, 2.5vw, 24px)'
                      : 'clamp(14px, 2.5vw, 16px)',
                }}
                className="title-i"
              >
                <i>{getSubCategoryName(props)}</i>
              </p>
            </div>
          )}
        </Col>

        <Col
          // span={(props.type === 'QuestionCard') ? 3 : 5} ---- commented by deepanshu because it was conditionally handled
          xs={8}
          sm={8}
          md={8}
          lg={8}
          xl={2}
          xxl={3}
        >
          <div className="date">
            <div className="p-title">Client Name</div>
            <h3 className="title-date title">
              <div style={{ marginTop: '20px', fontWeight: 'bold' }}>
                {props?.status?.question_status?.status_order >= 7 ? (
                  props?.user?.first_name + ' ' + props?.user?.last_name
                ) : (
                  <Tooltip
                    title={nameRecommendationConstantForToolTip?.title || ''}
                    color={nameRecommendationConstantForToolTip?.color}
                  >
                    {breakName(props?.user?.first_name, props?.user?.last_name)}
                  </Tooltip>
                )}
              </div>
            </h3>
          </div>
        </Col>
        {props.type === 'QuestionCard' && (
          <Col span={2}>
            <div className="date">
              <div className="p-title"># ID </div>
              <h3 className="title-date title" style={{ marginTop: '20px', fontWeight: 'bold' }}>
                {props?.id || '-'}
              </h3>
            </div>
          </Col>
        )}
        <Col xs={8} sm={8} md={8} lg={8} xl={2} xxl={3}>
          <div className="date">
            <div className="p-title">Request date</div>
            <h3 className="title-date title">{convertDateToTimezone(props?.created_at)}</h3>
            <h3 className="title-date title">{convertTimeToTimezone(props?.created_at)}</h3>
          </div>
        </Col>

        {getDynamicView(props.type)}
      </Row>

      <QuestionReplyModal
        open={open}
        close={() => setOpen(false)}
        questionId={props.id}
        rawData={selectedRowData}
        setShowRequestRejectModal={setShowRequestRejectModal}
      />

      {quotationModal && (
        <QuotationModal
          type="expert"
          open={quotationModal}
          close={() => setQuotationModal(false)}
          questionId={props.id}
          questionData={props}
          onRejectRequest={props?.onRejectRequestClick}
        />
      )}

      <RequestRejectModal
        visible={showRequestRejectModal}
        setShowModal={setShowRequestRejectModal}
        rawData={props}
        variant="expert"
      />
    </div>
  );
};

export default ExpertRequestCard;
